import { Chip, Stack } from '@mui/material';

import isEmpty from 'lodash/isEmpty';

import SlashIcon from '@/components/Icons/SlashIcon';

import { mapTrainingJobsCountByStatusToChips } from '../utils';
import { TrainingJobsCountByStatusToChipsProps } from './types';

function TrainingJobsCountByStatusToChips({
  jobsCountByStatus,
}: TrainingJobsCountByStatusToChipsProps) {
  if (isEmpty(jobsCountByStatus)) {
    return <Chip size="small" color="default" label="No training jobs" icon={<SlashIcon />} />;
  }

  return (
    <Stack direction="row" gap={0.5} alignItems="center">
      {mapTrainingJobsCountByStatusToChips(jobsCountByStatus)}
    </Stack>
  );
}

export default TrainingJobsCountByStatusToChips;
